import moment from 'moment'
const now = moment().utc()

export default {
  showWeekends: true,
  now: now
}



// WEBPACK FOOTER //
// ./src/config.js